import { styled } from '@lessonup/ui-components';
import React from 'react';

export type GenerateLessonWizardSteps = 'prompt' | 'review';

export interface GenerateLessonWizardProps {
  currentStep: GenerateLessonWizardSteps;
  promptStep: React.JSX.Element;
  reviewStep: React.JSX.Element;
}

export const GenerateLessonWizard = ({ promptStep, reviewStep, currentStep }: GenerateLessonWizardProps) => {
  return (
    <StyledWizard>
      {currentStep === 'prompt' && promptStep}
      {currentStep === 'review' && reviewStep}
    </StyledWizard>
  );
};

const StyledWizard = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  flex: 1;
  overflow-y: auto;
`;
